/* Import TinyMCE */
import tinymce from 'tinymce';
import ApplicationController from './application_controller';

require('../lib/tinymce');

export default class extends ApplicationController {
  static targets = ['input'];

  initialize() {
    this.defaults = {
      // Simplified toolbar as of 4/2025. If we decide to enable more, check out the commented list below.
      plugins: 'autoresize paste importcss code image link media table lists advlist',
      toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | numlist bullist | link image media',
      menubar: 'file edit view insert format tools table',
      menubar_sticky: true,
      menubar_sticky_offset: 61,
      toolbar_sticky: true,
      toolbar_sticky_offset: 61,
      image_advtab: true,
      importcss_append: true,
      min_height: 600,
      block_formats: 'Paragraph=p;Heading 2=h2;Heading 3=h3;Heading 4=h4;Heading 5=h5;Heading 6=h6;Preformatted=pre',
      image_caption: true,
      quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
      toolbar_mode: 'sliding',
      contextmenu: 'link image imagetools table',
      content_style: 'html { font-family: Roboto, sans-serif; line-height: 1.5; }',
      skin: false,
      content_css: false,
    };
  }

  connect() {
    const config = { target: this.inputTarget, ...this.defaults };
    tinymce.init(config);
  }

  disconnect() {
    tinymce.remove();
  }
}
